export default __webpack_public_path__ + "static/media/010_photo.0dc49929.jpg";